import React, { useRef, useState } from 'react';
import { StyleSheet, TouchableOpacity, View, useWindowDimensions } from 'react-native';
import Carousel, { ICarouselInstance } from 'react-native-reanimated-carousel';

import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { LaunchSlide } from '@/hooks/use-launch-slides';
import { designSystem } from '@/styles/styles';

import { LaunchCarouselItem } from './LaunchCarouselItem';

type LaunchCarouselProps = {
    launchSlides: LaunchSlide[];
};

const styles = StyleSheet.create({
    dot: {
        width: 8,
        height: 8,
        borderRadius: 60,
        marginHorizontal: 4,
        marginTop: 24,
    },
    activeDot: {
        backgroundColor: ds.colorValue.background.neutral.inverse,
    },
    inactiveDot: {
        backgroundColor: designSystem.colors.neutral300,
    },
});

export const LaunchCarousel = ({ launchSlides }: LaunchCarouselProps) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const carouselRef = useRef<ICarouselInstance | null>(null);
    const { width } = useWindowDimensions();

    const renderCarouselItem = () => {
        return <LaunchCarouselItem launchSlides={launchSlides} activeIndex={activeIndex} />;
    };

    const handleDotPress = (index: number) => {
        setActiveIndex(index);
        carouselRef.current?.scrollTo({ index: index });
    };

    return (
        <Box flex={1} alignItems={'center'}>
            <Carousel
                ref={carouselRef}
                width={width}
                data={launchSlides}
                autoPlay={true}
                autoPlayInterval={5000} // 5 seconds
                scrollAnimationDuration={250}
                onSnapToItem={index => {
                    setActiveIndex(index);
                }}
                renderItem={renderCarouselItem}
            />

            {launchSlides.length > 1 ? (
                <Box flexDirection={'row'} justifyContent={'center'} mb="s24">
                    {launchSlides.map((_, index) => {
                        const styledDotState = activeIndex === index ? styles.activeDot : styles.inactiveDot;
                        return (
                            <TouchableOpacity key={`pagination-dot-${index}`} onPress={() => handleDotPress(index)}>
                                <View style={[styles.dot, styledDotState]} />
                            </TouchableOpacity>
                        );
                    })}
                </Box>
            ) : null}
        </Box>
    );
};
